<section>
  <div class="nav-tabs border-bottom-0 popup-nav-tabs">
    <div class="slidemenu-modal mt-3">
      @for (tab of popUpTabDetails; track tab) {
        <div class="tabs-layout">
          <input type="radio" name="slideItemModal" class="slide-toggle-modal"/>
          <label id="{{tab.id}}" class="pop-up-label {{tab.isDisabled}}" (click)="switchTab(tab)">
            <div class="m-alignment d-inline-block">
              {{tab.name}}
            </div>
          </label>
        </div>
      }
    </div>
    <div class="modal-slider">

    </div>
  </div>
</section>